;(function () {

"use strict";

var ObjectListingTemplate = require('../views/templates/object-listing.html');

var FormView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.parent = opts.parent;
    console.log('init form view');
  },
  submit: function (e) {
    console.log('submitting form view');
    var type = this.$el.find('select').val();

    if (type === 'shop') {
      ShopifyApp.internalRedirect('/detail/shop/');
      return false;
    }

    ShopifyApp.Bar.loadingOn();
    $.get('/list/'+type, _.bind(function (d) {
      if (d.err) {
        alert(d.err);
        return;
      } else {
        this.parent.render(d);
      }
    }, this));

    return false;
  },
  events: {
    'submit': 'submit',
  }
});

var ListingView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    // this.page = 1;
    this.type = opts.type;
    console.log('init listing view');
    console.log(this.type);
    // console.log(this.page);
  },
  // next: function (e) {
  //   console.log('next');
  //   // if (this.page !== 1) {
  //     // this.page++;
  //     console.log($(e.currentTarget).data('link'))
  //     var link = $(e.currentTarget).data('link');
  //     this.fetch(link);
  //   // }

  //   return false;
  // },
  // prev: function (e) {
  //   console.log('prev');
  //   if (this.page !== 1) {
  //     this.page--;
  //     this.fetch();
  //   }

  //   return false;
  // },
  render: function (d) {
    // console.log('rendering');
    // console.log(d);
    ShopifyApp.Bar.loadingOff();

    var objects = d.data[first(d.data)];
    var html = _.template(ObjectListingTemplate)({ objects: objects, type: this.type, links: d.links });

    this.$el.find('.listing').html(html);
    this.$el.html(html);
  },
  fetch: function (e) {
    var link = $(e.currentTarget).data('link');
    var direction = $(e.currentTarget).data('direction')
    // console.log(link);
    ShopifyApp.Bar.loadingOn();
    $.get('/list/'+this.type+'/'+encodeURIComponent(link)+'?direction='+direction).then(_.bind(this.render, this));
  },
  destroy() {
    console.log('destroying');
    this.undelegateEvents();
    this.$el.removeData().unbind();
  },
  events: {
    'click .next': 'fetch',
    'click .prev': 'fetch'
  }
});

var first = function (obj) {
  for (var a in obj) return a;
};

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init list view');
    new FormView({ el: this.$el.find("form").first(), parent: this });
  },
  render: function (d) {
    ShopifyApp.Bar.loadingOff();

    var type = this.$el.find('form select').val(); /* for consistency */
    var objects = d.data[first(d.data)];
    var html = _.template(ObjectListingTemplate)({ objects: objects, type: type, links: d.links });
    this.$el.find('.listing').html(html);

    if (this.lv) {
      this.lv.destroy();
    }

    this.lv = new ListingView({ el: this.$el.find('.listing'), type: type });
  }
});

module.exports = PageView;

}());